import { components as c } from "@/components";
import useUsersOrganisationsRolesQuery from "@/features/auth/api/selectUsersOrganisationsRoles";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { useTemplateStore } from "@/features/templates/stores/useTemplateStore";
import { useAuth } from "@/utils/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import type { OptionT } from "../../../../../components/form/Select";

export const AdminForm = () => {
	const auth = useAuth();
	const { organisation_id, setOrganisation } = useTemplateStore();
	const { markStepComplete, nextStep, setCurrentStep } =
		useTemplateNavigationStore();
	const { data: organisations } = useUsersOrganisationsRolesQuery(auth.id);
	const navigate = useNavigate();

	// Set this page as the current step
	useEffect(() => {
		setCurrentStep("organisation"); // Organisation is the first step (index 0)
	}, [setCurrentStep]);

	const form = useForm({
		defaultValues: {
			organisation_id,
		},
	});

	useEffect(() => {
		const subscription = form.watch((value) => {
			if (value.organisation_id) {
				const selectedOrg = organisations?.find(
					(org) => org.organisation_id === value.organisation_id,
				);
				if (selectedOrg) {
					setOrganisation({
						organisation_id: selectedOrg.organisation_id ?? "",
						organisation_name: selectedOrg.organisation_name ?? "",
					});
				}
			}
		});
		return () => subscription.unsubscribe();
	}, [form, setOrganisation, organisations]);

	const handleNext = () => {
		if (organisation_id) {
			markStepComplete("organisation");
			nextStep();
			navigate({ to: "/new/diary/$templateId/trackers" });
		}
	};

	return (
		<c.ui.Form {...form}>
			<form className="w-full form">
				<c.fc.ComboBox
					options={organisations?.map(
						(org) =>
							({
								label: org.organisation_name,
								value: org.organisation_id,
							}) ?? [],
					) as OptionT[]}
					name="organisation_id"
					label="Organisation"
					placeholder="Select an organisation"
				/>
				<div className="flex justify-end gap-4 mt-8">
					<c.ui.Button type="button" onClick={handleNext}>
						Next
					</c.ui.Button>
				</div>
			</form>
		</c.ui.Form>
	);
};

export const Route = createFileRoute(
	"/_app/new/diary/$templateId/organisation",
)({
	component: AdminForm,
});
